// src/services/http.js
import axios from 'axios';
const http = axios.create({ baseURL: process.env.VUE_APP_SERVER_URL });
http.interceptors.request.use((cfg) => {
const user = JSON.parse(localStorage.getItem('user'));
if (user && user.token) cfg.headers.authorization = user.token;
return cfg;
});
export default http;